export const NO_RESULTS_TEXT = 'No Results'
export const PATIENT_INPUT_PLACEHOLDER = 'Type Patient Name'
